module.exports = __webpack_public_path__ + "static/img/no-spray-list.a1f865e.svg";